import './_product-card-price.scss';

export default () => {};
